import React from "react";
import { Typography, Form, Select, Space, Avatar, Image } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const AssignZone = (props) => {
  return (<>
    <Space direction="horizontal" style={{marginBottom: '20px'}}>
      <Space>
        {props?.value?.profileImage ? (
          // <Image alt="Profile Image" style={{height: "75px"}} src={props?.value?.profileImage}/>
          <img src={props?.value?.profileImage} style={{height: "75px"}} alt="Profile Image"/>
        ) : (
          <Avatar shape="square" size={75} icon={<UserOutlined />} />
        )}
      </Space>
      <Space direction="vertical">
        {props?.value?.fullName ? <Title level={5} style={{ margin: "0" }}>{props?.value?.fullName}</Title> : "-"}
        {props?.value?.display_id ? <Text>{props?.value?.display_id}</Text> : "-"}
      </Space>
    </Space>

    <Form.Item
      name={["zoneIds"]}
      label="Select Zone"
      rules={[{ required: true, message: "Zone is Required" }]}
    >
      <Select
        showSearch
        allowClear
        mode="multiple"
        optionFilterProp="children"
        filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={props?.zoneOption}
        style={{ minWidth: 300}}
        placeholder="Zone"
      />
    </Form.Item>
  </>);
};
export default AssignZone;
